var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-tags-input',{staticClass:"w-100",attrs:{"placeholder":_vm.placeholder,"tags":_vm.tags,"disabled":_vm.disabled},on:{"tags-changed":_vm.updateTags},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})
}
var staticRenderFns = []

export { render, staticRenderFns }